import { Typography, Box, useTheme, TextField,  Divider, Button, Grid,  Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import  { useState, useEffect } from "react";



import { DataGrid } from "@mui/x-data-grid";


import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";

const AddStorageLocation = ({ onClose, handleBackWinderMachineEntry, open }) => {




    const theme = useTheme();
    const colors = tokens(theme.palette.mode);


    const [storageLocationList, setStorageLocationList] = useState([]);
    const [result, setresult] = useState([]);
    const [storageLocationCode, setStorageLocationCode] = useState('');
    const [operatorEmailID, setOperatorEmailID] = useState('');
    const [isDataLoaded, setIsDataLoaded] = useState(false);

    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const OperatorColumns = [
        { field: "id", headerName: "SNo", hide: true, flex: 1, cellClassName: "name-column--cell" },
        { field: "storage_location_code", headerName: "Location Code", flex: 1, cellClassName: "name-column--cell" },       
    ];
    const callback = () => {
        handleBackWinderMachineEntry();
    };

    // Get Shift Codes
    useEffect(() => {
        if (!isDataLoaded) {
            const para = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
            }
            callApi(API_ENDPOINTS.PRODUCTION_STORAGE_LOCATION_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setStorageLocationList(data);

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
    }, [isDataLoaded]);



    const handleSaveOperator = () => {

        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (storageLocationCode === '') {
            validation_msg += 'Please enter operator code.\n';
            isValid = false;
        }      


        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_location_code: storageLocationCode,
                p_user_name:localStorage.getItem('userID')
            }

            callApi(API_ENDPOINTS.PRODUCTION_ADD_STORAGE_LOCATION, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].id === 0) {
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('New Location Code Added Successfully.', { position: toast.POSITION.BOTTOM_CENTER });

                            const para = {
                                p_companyid: localStorage.getItem('companyid'),
                                p_plantid: 1,
                            }
                            callApi(API_ENDPOINTS.PRODUCTION_STORAGE_LOCATION_LIST, 'POST', { 'Content-Type': 'application/json' }, para)
                                .then(data => {
                                    if (data && data.length > 0) {
                                        setStorageLocationList(data);

                                    }
                                })
                                .catch(error => {
                                    alert(error.message);
                                });

                        }
                        else if(data[0].id==1){
                            toast.success('New Location Code Already Exist.', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }


    };



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography>Add Storage Location</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 1 }} >
                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >                            

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Location Code </Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={storageLocationCode} onChange={(e) => setStorageLocationCode(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>
                                </Box>



                            </Box>
                            {/* <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={5}

                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Email Address</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 8',
                                        xl: 'span 8',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={operatorEmailID} onChange={(e) => setOperatorEmailID(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>
                                </Box>



                            </Box> */}



                            <Box marginTop={5}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button onClick={handleSaveOperator} size="small" variant="contained" color="secondary">
                                        Save
                                    </Button>
                                   
                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6"> Available Opreator List</Typography>
                                <Divider sx={{ marginTop: '10px' }} />
                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"
                                    padding={1}
                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={storageLocationList} columns={OperatorColumns}/>

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>




            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>              

                <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddStorageLocation;